// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"styles_errorMessage__1qxMb","card":"styles_card__Asyzm","profileInfo":"styles_profileInfo__755Z6","placeholder":"styles_placeholder__3f0_D"};